import { cn } from '@/lib/utils';

interface LoadingAnimationProps {
  fullScreen?: boolean;
  text?: string;
  className?: string;
  backgroundColor?: string;
}

const spinnerStyles = `
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
  @keyframes pulse-ring {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1.5);
      opacity: 0;
    }
  }
`;

export function LoadingAnimation({
  fullScreen = false,
  text = 'Loading...',
  className,
  backgroundColor = 'bg-background/80',
}: LoadingAnimationProps) {
  const containerClasses = fullScreen
    ? `fixed inset-0 flex items-center justify-center ${backgroundColor} backdrop-blur-sm z-50`
    : 'flex flex-col items-center justify-center gap-4';

  return (
    <>
      <style>{spinnerStyles}</style>
      <div
        className={cn(containerClasses, className)}
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        {/* Spinner Container */}
        <div className="flex flex-col items-center gap-6">
          {/* Pulsing Ring Background */}
          <div className="relative w-16 h-16">
            {/* Outer pulsing ring */}
            <div
              className="absolute inset-0 rounded-full bg-green-400/20"
              style={{
                animation: 'pulse-ring 2s ease-out infinite',
              }}
            />
            
            {/* Main spinner */}
            <div
              className="absolute inset-0 rounded-full border-4 border-slate-200"
              style={{
                borderTopColor: '#22c55e',
                borderRightColor: '#16a34a',
                animation: 'spin 1s linear infinite',
              }}
            />
            
            {/* Inner dot */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
            </div>
          </div>

          {/* Loading Text */}
          {text && (
            <p className="text-sm text-muted-foreground font-medium">{text}</p>
          )}
        </div>
      </div>
    </>
  );
}
